import { node, oneOf } from "prop-types";

import { fontWeightOptions } from "../constants/fontWeightOptions";
import * as S from "./styled";

const SecondaryMedium = S.SecondaryMediumBase;

SecondaryMedium.displayName = "SecondaryMedium";

SecondaryMedium.propTypes = {
  children: node.isRequired,
  weight: oneOf([fontWeightOptions.LIGHT, fontWeightOptions.REGULAR])
};

SecondaryMedium.defaultProps = {
  weight: fontWeightOptions.LIGHT
};

export default SecondaryMedium;
